import * as React from "react";

function SvgContextPanelCollapse() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#284672 " width="5" height="22" viewBox="0 0 5 22">
            <g id="Icon_feather-more-vertical" data-name="Icon feather-more-vertical" transform="translate(-15.5 -5)">
                <path id="Path_68" data-name="Path 68" d="M19.5,18A1.5,1.5,0,1,1,18,16.5,1.5,1.5,0,0,1,19.5,18Z" transform="translate(0 -2)" fill="#284672 " stroke="#284672 " stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path id="Path_69" data-name="Path 69" d="M19.5,7.5A1.5,1.5,0,1,1,18,6,1.5,1.5,0,0,1,19.5,7.5Z" fill="#284672 " stroke="#284672 " stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path id="Path_70" data-name="Path 70" d="M19.5,28.5A1.5,1.5,0,1,1,18,27,1.5,1.5,0,0,1,19.5,28.5Z" transform="translate(0 -4)" fill="#284672 " stroke="#284672 " stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            </g>
        </svg>
    )
}
export default SvgContextPanelCollapse;


// WEBPACK FOOTER //
// ./src/iconComponents/ContextPanelCollapse.js